import React from 'react';
import PropTypes from 'prop-types';

import InputWithMask from '../inputs/InputWithMask';
import { AccountNumberInput } from '../sto';

const POSTAL_CODE_REGEX = /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]\d[ABCEGHJKLMNPRSTVWXYZabceghjklmnprstvwxyz]\d[ABCEGHJKLMNPRSTVWXYZabceghjklmnprstvwxyz]\d$/i;
function AccountDetails(props) {
    const { accountNumber, phoneNumber, postalCode, setFormField } = props;
    const formErrors = {
        accountNumber: 'form.registration.accountNumber.field.error',
        phoneNumber: 'form.registration.phoneNumber.field.error',
        postalCode: 'form.registration.postalCode.field.error',
    };

    const handleAccountNumberChange = (input) => {
        setFormField('accountNumber', input);
    };

    const handlePhoneNumber = (e) => {
        let value = e.target.value.replace(/\s/g, '');
        value = value.replace(/\D/g, '');
        const isValidPhoneLength = value.length === 10;
        const isValid = value.length < 10 && phoneNumber.isValid === null ? null : isValidPhoneLength;
        const errorMessage = isValid === false ? formErrors['phoneNumber'] : null;

        setFormField('phoneNumber', { errorMessage, isValid, value });
    };

    const handlePhoneNumberBlur = () => {
        const isValid = phoneNumber.value.length === 10;
        const errorMessage = !isValid ? formErrors['phoneNumber'] : null;

        setFormField('phoneNumber', { errorMessage, isValid });
    };

    const handlePostalCode = (e) => {
        const value = e.target.value.replace(/\s/g, '');
        const isValidPostalLength = value.length === 6 && POSTAL_CODE_REGEX.test(value);
        const isValid = value.length < 6 && postalCode.isValid === null ? null : isValidPostalLength;
        const errorMessage = isValid === false ? formErrors['postalCode'] : null;

        setFormField('postalCode', { errorMessage, isValid, value });
    };

    const handlePostalCodeBlur = () => {
        const isValid = postalCode.value.length === 6 && POSTAL_CODE_REGEX.test(postalCode.value);
        const errorMessage = !isValid ? formErrors['postalCode'] : null;

        setFormField('postalCode', { errorMessage, isValid });
    };

    return (
        <React.Fragment>
            <AccountNumberInput
                errorMessage={accountNumber.errorMessage}
                isValid={accountNumber.isValid}
                label="form.registration.accountNumber.field"
                onBlur={handleAccountNumberChange}
                onChange={handleAccountNumberChange}
                placeholder="form.registration.accountNumber.placeholder"
                value={accountNumber.value}
            />

            <InputWithMask
                errorMessage={phoneNumber.errorMessage}
                inputType="tel"
                isValid={phoneNumber.isValid}
                label="form.registration.phoneNumber.field"
                mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                name="phoneNumber"
                onBlur={handlePhoneNumberBlur}
                onChange={handlePhoneNumber}
                placeholder="form.registration.phoneNumber.placeholder"
                value={phoneNumber.value}
            />

            <InputWithMask
                errorMessage={postalCode.errorMessage}
                isValid={postalCode.isValid}
                label="form.registration.postalCode.field"
                mask={[
                    /[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]/,
                    /\d/,
                    /[ABCEGHJKLMNPRSTVWXYZabceghjklmnprstvwxyz]/,
                    ' ',
                    /\d/,
                    /[ABCEGHJKLMNPRSTVWXYZabceghjklmnprstvwxyz]/,
                    /\d/,
                ]}
                name="postalCode"
                onBlur={handlePostalCodeBlur}
                onChange={handlePostalCode}
                placeholder="form.registration.postalCode.placeholder"
                value={postalCode.value}
            />
        </React.Fragment>
    );
}

AccountDetails.propTypes = {
    accountNumber: PropTypes.exact({
        errorMessage: PropTypes.string,
        isValid: PropTypes.bool,
        value: PropTypes.string.isRequired,
    }).isRequired,
    phoneNumber: PropTypes.exact({
        errorMessage: PropTypes.string,
        isValid: PropTypes.bool,
        value: PropTypes.string.isRequired,
    }).isRequired,
    postalCode: PropTypes.exact({
        errorMessage: PropTypes.string,
        isValid: PropTypes.bool,
        value: PropTypes.string.isRequired,
    }).isRequired,
    setFormField: PropTypes.func.isRequired,
};

export default AccountDetails;
